import {filter, orderBy, find, unionBy} from 'lodash'

export const getCompany = ({ info }) => info

export const getCurrencies = ({ currencies }) => orderBy(currencies, ['name'])

export const getMembers = ({ members }) => orderBy(members, ['full_name'])

export const isTrialExpired = ({ tenant }) => tenant.status === 'trial' && tenant.trial_days_left === 0

export const isInactiveAccount = ({ tenant }) => {
    return tenant.status === 'suspended' ||
        tenant.status === 'canceled' ||
        (tenant.status === 'trial' && tenant.trial_days_left === 0)
}

export const getTenant = ({ tenant }) => tenant

export const getTenantCurrency = ({ user, currencies, tenant }) => find(currencies, { id: parseInt(tenant.currency_id) })

export const getActiveMembers = ({ members }) => {
    let active = filter(orderBy(members, ['full_name']), { active: 1 })
    return (id = null) => (id === '' || id === null) ? active : orderBy(unionBy(active, [find(members, { id })], 'id'), ['full_name'])
}

export const getInactiveMembers = ({ members }) => filter(orderBy(members, ['full_name']), { active: 0 })



// WEBPACK FOOTER //
// ./src/modules/company/store/getters.js